import React from "react";
import Reports from "../pages/Reports";
import Page from "./Page";

export default function ReportContainer(props: any) {
    return (
        <Page Body={Reports} />
    )
}